import { Button, ButtonGroup } from '@chakra-ui/button';
import React, { useEffect, useState } from 'react';
import Layout from '../../components/Layout';
import FAQ from '@/components/FAQ';
import classes from './styles.module.scss';
import { PACKAGE } from '../../constants';
import { StorageService } from '../../service/Storage';
import { useRouter } from 'next/router';
import FAQLanguageTitle from '@/components/FAQLanguageTitle';

const SUPPORTED_LANGS = ['en', 'hi', 'mr', 'gu', 'id'];

export default function Faq(props) {
  const router = useRouter();
  
  const getLangFromQuery = () => {
    const queryLang = router.query.lang;
    // Map 'in' to 'id' for Indonesian
    const mappedLang = queryLang === 'in' ? 'id' : queryLang;
    // Validate against supported languages
    return SUPPORTED_LANGS.includes(mappedLang) ? mappedLang : 'en';
  };

  const [lang, setLang] = useState('en');

  useEffect(() => {
    const initialLang = getLangFromQuery();
    setLang(initialLang);
    StorageService.setXPN(PACKAGE);
  }, [router.query.lang]);

  return (
    <Layout>
      <div className={classes.FaqPage}>
        <FAQLanguageTitle lang={lang} />
        <div style={{ margin: '1rem 0rem' }}>
          <ButtonGroup variant="solid" spacing="0" size="xs" isAttached>
            <Button
              colorScheme={lang === 'en' ? 'brand' : 'gray'}
              onClick={() => setLang('en')}
            >
              English
            </Button>
            <Button
              colorScheme={lang === 'hi' ? 'brand' : 'gray'}
              onClick={() => setLang('hi')}
            >
              हिंदी
            </Button>
            <Button
              colorScheme={lang === 'mr' ? 'brand' : 'gray'}
              onClick={() => setLang('mr')}
            >
              मराठी
            </Button>
            <Button
              colorScheme={lang === 'gu' ? 'brand' : 'gray'}
              onClick={() => setLang('gu')}
            >
              ગુજરાતી
            </Button>
            <Button
              colorScheme={lang === 'id' ? 'brand' : 'gray'}
              onClick={() => setLang('id')}
            >
              Indonesian
            </Button>
          </ButtonGroup>
        </div>

        <FAQ lang={lang} classes={classes} />
      </div>
    </Layout>
  );
}
